module.exports = __webpack_public_path__ + "static/media/single-orange.f7380f1a.svg";